
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/[...dynamic]",
      function () {
        return require("private-next-pages/loyalty/[...dynamic].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/[...dynamic]"])
      });
    }
  